export default __webpack_public_path__ + "static/media/Master.d2c63bf3.png";